import React from "react";
import styles from "../Banner/Banner.module.css";
import { DynamicSlider } from "../../../homeComun/components/DynamicSlider";

export const Nanner = () => {
  return (
    <div className={styles.contenedor}>
      <DynamicSlider section="Dist-Home" subSection="Banner 2" />
    </div>
  );
};
